import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
  } from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import * as actions from '../../redux/actConfDialog/actions';

const openDialog = props => {
    props.openDialog();
}

const closeDialog = props => {
    props.closeDialog();
}

class ActionConfirmDialog extends React.Component{
    submitBtnClick(){
        this.props.submitFunc();
    }
    render(){
        return (
            <div>
                <Dialog
                    open={this.props.actConfDialog.dialogOpen}
                    onClose={()=>closeDialog(this.props)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    {this.props.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>closeDialog(this.props)} color="primary">
                    Cancel
                    </Button>
                    <Button onClick={this.submitBtnClick.bind(this)} color="primary" autoFocus>
                    Submit
                    </Button>
                </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        actConfDialog: state.actConfDialog
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      openDialog: () => {
         dispatch(actions.openDialog())  
      },
      closeDialog: () => {
         dispatch(actions.closeDialog())  
      }
    }
}

ActionConfirmDialog.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    submitFunc: PropTypes.func.isRequired   
}

export default connect(mapStateToProps,mapDispatchToProps)(ActionConfirmDialog);


// WEBPACK FOOTER //
// ./src/components/ActionConfirmDialog/ActionConfirmDialog.js